import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "point",
  "use": "point-usage",
  "viewBox": "0 0 12 15",
  "content": "<symbol viewBox=\"0 0 12 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"point\">\n<path d=\"M6 0.75C3.07422 0.75 0.75 3.10156 0.75 6.02734C0.75 8.13281 1.46094 8.73438 5.45312 14.4766C5.69922 14.8594 6.27344 14.8594 6.51953 14.4766C10.5117 8.73438 11.25 8.13281 11.25 6.02734C11.25 3.10156 8.89844 0.75 6 0.75ZM6 8.1875C4.76953 8.1875 3.8125 7.23047 3.8125 6C3.8125 4.79688 4.76953 3.8125 6 3.8125C7.20312 3.8125 8.1875 4.79688 8.1875 6C8.1875 7.23047 7.20312 8.1875 6 8.1875Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/point.svg
// module id = ydcY
// module chunks = 13